window.addEventListener('DOMContentLoaded', () => {
    let overlay = document.querySelector('.overlay');

    document.querySelector('.link__target').addEventListener('click', (event) => {
        event.preventDefault();

        overlay.style.display = 'flex';
    });

    overlay.querySelector('.buttons__button--cancel').addEventListener('click', () => {
        overlay.style.display = 'none';
    });

    overlay.querySelector('.modal__form').addEventListener('submit', (event) => {
        event.preventDefault();

        for (let input of event.target.elements) {
            if (input.type === 'text') {
                input.dispatchEvent(new Event('blur'));
            }
        }
    });
});